import React, { useEffect, useState } from "react";
import schoolApi from "../../api/schoolApi";
import "./FeeReceipt.css";
import "react-toastify/dist/ReactToastify.css";
import { Col, Row } from "react-bootstrap";
import jwt_decode from "jwt-decode";
const parseSafe = (val) => {
  if (typeof val === "string") return parseInt(val.replace(/,/g, "")) || 0;
  return parseInt(val) || 0;
};
const FeeReceipt = React.forwardRef(({ receiptData, onReady }, receiptRefs) => {
  const [studentRecord, setStudentRecord] = useState();
  const [headRecords, setHeadRecords] = useState([]);
  const [depoMonths, setMonths] = useState([]);
  const [depositRecords, setdepositRecords] = useState([]);
  const [filterMonths, setFilterMonths] = useState([]);
  const [tenantCode, setTenantCode] = useState(null);
  const [overallPaidTotal, setOverallPaidTotal] = useState(0);
  useEffect(() => {
    if (receiptData) {
      setStudentRecord(null);
      setHeadRecords([]);
      setMonths([]);
      setdepositRecords([]);
      setFilterMonths([]);
      setOverallPaidTotal(0);

      async function init() {
        try {
          sessionStorage.getItem("token");
          const user = jwt_decode(sessionStorage.getItem("token"));
          setTenantCode(user.tenantcode);
          let session = receiptData?.sessionid
            ? receiptData?.sessionid
            : receiptData?.session_id;

          // 1. First fetch the CURRENT receipt to get the reliable session ID
          const result = await schoolApi.fetchFeeDepositsByStudentId(
            receiptData?.student_addmission_id,
            null, // session can be null here as we have deposit_id
            receiptData?.deposit_id
          );

          if (!result || result.success === false) {
            return;
          }

          const depoRecordsResult = result?.result?.[0] || result?.[0];
          const sessionToUse = depoRecordsResult?.session_id || depoRecordsResult?.sessionid || session;

          // 2. Now fetch ALL receipts for this student in this session for history
          const allReceiptsResult = await schoolApi.fetchFeeDepositsByStudentId(
            receiptData?.student_addmission_id,
            sessionToUse
          );

          const allReceipts = allReceiptsResult?.result || [];
          const depoRecords = depoRecordsResult;

          const allInstallmentsResult = await schoolApi.getallIntsallment(
            receiptData?.student_addmission_id,
            sessionToUse
          );

          const allMasterInstallments = allInstallmentsResult?.result || allInstallmentsResult || [];

          // Calculate Previous Paid Total using Receipt Number sequencing
          const getFirstReceiptNum = (str) => {
            if (!str) return 0;
            const match = String(str).match(/\d+/);
            return match ? parseInt(match[0]) : 0;
          };

          const currentReceiptNum = getFirstReceiptNum(depoRecords?.receipt_number);
          console.log("allReceipts =>", allReceipts);
          console.log("currentReceiptNum =>", currentReceiptNum);
          const previousReceiptsTotal = allReceipts
            .filter(r => {
              const rNum = getFirstReceiptNum(r.receipt_number);
              // Receipt must have a lower number than the current one
              return rNum < currentReceiptNum;
            })
            .reduce((acc, r) => acc + parseSafe(r.amount || 0), 0);
          console.log("previousReceiptsTotal =>", previousReceiptsTotal);

          setOverallPaidTotal(previousReceiptsTotal);

          const current_session = await schoolApi.getSessionById(depoRecords?.session_id || depoRecords?.sessionid);
          const filteredMonthsName = getMonthNamesBetweenDates(
            current_session?.result?.startdate,
            current_session?.result?.enddate
          );
          setFilterMonths(filteredMonthsName);

          // Calculate the true overall total paid UP TO this receipt's sequence
          const currentInsts = depoRecords?.installments || [];
          const maxOrderNo = currentInsts.length > 0 ? Math.max(...currentInsts.map(i => Number(i.orderno || 0))) : 999;

          setOverallPaidTotal(previousReceiptsTotal);


          setdepositRecords(depoRecords);
          let netPayableAmount = 0;
          let headArray = [];
          let totalTransportfee = 0;
          let installmentTotalDueAmount = 0;
          let months = [];


          if (depoRecords?.installments?.length > 0) {
            depoRecords.installments = depoRecords?.installments
              .map((installment) => {
                const notmonthlytype = installment.month.split(" to ");



                if (notmonthlytype.length === 1) {
                  return filteredMonthsName.includes(installment.month)
                    ? installment
                    : null;
                } else {
                  const [startMonth, endMonth] = notmonthlytype.map((m) =>
                    m.trim()
                  );
                  const startIndex = filteredMonthsName.indexOf(startMonth);
                  const endIndex = filteredMonthsName.indexOf(endMonth);

                  if (startIndex !== -1 && endIndex !== -1) {
                    const monthsInRange = filteredMonthsName.slice(
                      startIndex,
                      endIndex + 1
                    );

                    return { ...installment, expandedMonths: monthsInRange };
                  } else {
                    console.warn(
                      "Invalid month range in installment: ",
                      installment.month
                    );
                    return null;
                  }
                }
              })
              .filter(Boolean);

            depoRecords.installments.sort((a, b) => {
              const aFirstMonth = Array.isArray(a.expandedMonths)
                ? a.expandedMonths[0]
                : a.month;
              const bFirstMonth = Array.isArray(b.expandedMonths)
                ? b.expandedMonths[0]
                : b.month;
              return (
                filteredMonthsName.indexOf(aFirstMonth) -
                filteredMonthsName.indexOf(bFirstMonth)
              );
            });


          }

          depoRecords?.installments?.forEach((res) => {
            if (!months.some((m) => m.month === res.month)) {
              months.push({ month: res.month });
            }

            res.heads.forEach((head) => {
              const existingHead = headArray.find(
                (prev) => prev.headid === head.headid
              );

              if (existingHead) {
                existingHead.head_amount += parseInt(head.head_amount);
                if (!existingHead.month.includes(res.month)) {
                  existingHead.month.push(res.month);
                }

                head?.concession?.forEach((heds) => {
                  if (!existingHead.discount) existingHead.discount = [];
                  const existingDiscount = existingHead.discount.find(
                    (exds) => exds.discountid === heds.discountid
                  );

                  if (existingDiscount) {
                    existingDiscount.concession_value += heds.concession_value;
                  } else {
                    existingHead.discount.push({ ...heds });
                  }
                });
              } else {
                headArray.push({
                  ...head,
                  head_amount: parseInt(head.head_amount),
                  month: [res.month], // Store as array for consistency
                  discount: head?.concession ? [...head.concession] : [],
                });
              }
            });

            installmentTotalDueAmount += parseInt(res.installment_due_amount);
            totalTransportfee += parseInt(res.transport_fee);
          });

          // 1. Add Transport Fee row
          const totalTransportPaidInReceipt = depoRecords?.installments?.reduce((acc, inst) => acc + parseSafe(inst.transport_fee_paid || 0), 0) || 0;
          headArray.push({
            headname: "Transport Fee",
            head_amount: totalTransportfee,
            month: months.map(m => m.month),
            paidAmountOverride: totalTransportPaidInReceipt
          });

          // 2. Calculate and add Late Fee row
          let totalChargedLateFeeInReceipt = 0;
          let totalPaidInThisReceiptLateFee = parseSafe(depoRecords?.late_fee || 0);
          depoRecords?.installments?.forEach(inst => {
            // Find the most accurate charged amount for this installment's month.
            // Check the specific deposit record first, then fallback to the overall installment master data.
            const masterInst = allMasterInstallments?.find(i => i.month === inst.month);

            const charged = Math.max(
              parseSafe(inst.pushed_late_fee || 0),
              parseSafe(inst.late_fee || 0),
              parseSafe(masterInst?.pushed_late_fee || 0),
              parseSafe(masterInst?.late_fee || 0)
            );

            totalChargedLateFeeInReceipt += charged;
          });
          let totalPushedLateFee = Math.max(totalChargedLateFeeInReceipt, totalPaidInThisReceiptLateFee);

          headArray.push({
            headname: `Late Fee (Charged: ${totalPushedLateFee}, Total Paid: ${parseSafe(result.result[0].cumulative_late_fee)})`,
            head_amount: totalPushedLateFee,
            month: months.map(m => m.month),
            paidAmountOverride: totalPaidInThisReceiptLateFee
          });

          // 3. Add Previous Due row
          headArray.push({
            headname: "Previous Due",
            head_amount: parseSafe(depoRecords?.previous_due || 0),
            month: months.map(m => m.month),
            paidAmountOverride: 0
          });

          depoRecords.total_installment_gross = parseSafe(result.result[0].total_installment_gross);
          depoRecords.total_installment_due = parseSafe(result.result[0].total_installment_due);

          const headsTotal = headArray.reduce((acc, h) => acc + h.head_amount, 0);
          if (depoRecords.total_installment_gross < headsTotal) {
            depoRecords.total_installment_gross = headsTotal;
          }

          depoRecords.netPayableAmount = 0; // Handled by footer logic now

          setMonths(months);


          depoRecords.previous_paid_total = depoRecords?.previous_paid || 0;
          setStudentRecord(depoRecords);
          setHeadRecords(headArray.filter((res) => res.head_amount > 0));

        } catch (error) { }
      }
      init();
    }
  }, [receiptData]);

  useEffect(() => {
    if (studentRecord && onReady) {
      onReady();
    }
  }, [studentRecord, onReady]);


  function getMonthNamesBetweenDates(start, end) {
    const startDate = new Date(start);
    const endDate = new Date(end);
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];

    const result = [];
    let currentDate = new Date(startDate);

    while (currentDate <= endDate) {
      const monthName = monthNames[currentDate.getMonth()];
      if (!result.includes(monthName)) {
        result.push(monthName);
      }

      currentDate.setMonth(currentDate.getMonth() + 1);
    }

    return result;
  }

  const convertNumberToWords = (num) => {
    const a = [
      "",
      "One",
      "Two",
      "Three",
      "Four",
      "Five",
      "Six",
      "Seven",
      "Eight",
      "Nine",
      "Ten",
      "Eleven",
      "Twelve",
      "Thirteen",
      "Fourteen",
      "Fifteen",
      "Sixteen",
      "Seventeen",
      "Eighteen",
      "Nineteen",
    ];
    const b = [
      "",
      "",
      "Twenty",
      "Thirty",
      "Forty",
      "Fifty",
      "Sixty",
      "Seventy",
      "Eighty",
      "Ninety",
    ];
    const g = ["", "Thousand", "Million", "Billion", "Trillion"];
    if ((num = num.toString()).length > 15) return "too large";
    let n = ("000000000000000" + num).substr(-15).match(/.{3}/g);
    let str = "";
    for (let i = 0; i < n.length; i++) {
      let hundreds = parseInt(n[i][0]);
      let tens = parseInt(n[i][1]);
      let units = parseInt(n[i][2]);
      let word = "";
      if (hundreds > 0) {
        word += a[hundreds] + " hundred ";
      }
      if (tens > 1) {
        word += b[tens] + " " + a[units];
      } else {
        word += a[10 * tens + units];
      }
      if (word.trim()) {
        str += word + " " + g[n.length - 1 - i] + " ";
      }
    }
    return str.replace(/\s+/g, " ").trim();
  };
  const totalFees = parseSafe(studentRecord?.total_installment_gross) > 0
    ? parseSafe(studentRecord?.total_installment_gross)
    : headRecords?.reduce((acc, item) => acc + parseSafe(item?.head_amount), 0);

  const totalDiscount = parseSafe(studentRecord?.discount);

  // Distribute payment across headRecords for display
  const headRecordsWithPayment = headRecords.map(item => {
    const installments = studentRecord?.installments || [];
    const itemMonths = Array.isArray(item.month) ? item.month : [];

    // Find all installments that match ANY of the months in this merged head record
    const matchingInsts = installments.filter(inst =>
      itemMonths.some(m => m?.trim().toLowerCase() === inst.month?.trim().toLowerCase())
    );

    let displayPaidAmount = 0;
    let displayDiscount = 0;

    if (item.paidAmountOverride !== undefined) {
      displayPaidAmount = item.paidAmountOverride;
      displayDiscount = item.displayDiscount || 0;
    } else {
      // For Tuition/Regular Heads: Sum of what was paid in ALL matching months in this receipt
      displayPaidAmount = matchingInsts.reduce((acc, inst) => acc + parseSafe(inst.deposited_amount || 0), 0);

      // Sum up discounts across matching months
      displayDiscount = matchingInsts.reduce((acc, inst) => acc + parseSafe(inst.installment_discount || 0), 0);

      // Fallback to head level discount if installment level is zero
      if (displayDiscount === 0) {
        displayDiscount = parseSafe(item.discount?.reduce((acc, d) => acc + parseSafe(d.concession_value), 0) || 0);
      }
    }

    return { ...item, paidInThisReceipt: displayPaidAmount, displayDiscount };
  });



  return (
    <>
      <div className="fee-receipt-container-receipt">
        {studentRecord ? (
          <div
            id="reportContent"
            ref={receiptRefs}
            className="fee-receipt-receipt"
          >
            {["Office Copy", "Parent Copy"].map((copyType, idx) => (
              <div key={idx} className="receipt-copy-receipt">
                <header className="header-receipt">
                  <Row>
                    <Col lg={3}>
                      <img
                        src={`/${tenantCode}-sidebar-logo.png`}
                        style={{ width: "100px", height: "100px" }}
                        alt=""
                      />
                    </Col>
                    <Col lg={6}>
                      <h1>{studentRecord.school_name}</h1>
                      <p>
                        {studentRecord.school_address},<br />
                        State - {studentRecord.state}, {studentRecord.country},
                        <br />
                        Pin code - {studentRecord.pincode}
                      </p>
                    </Col>
                    <Col lg={3}>
                      <p className="float-end">{copyType}</p>
                    </Col>
                  </Row>
                </header>
                { }
                <h4 class="text-center border-dark border-top border-bottom container-fluid">
                  Fee Receipt ({studentRecord.session})
                </h4>
                { }
                <div className="receipt-info-receipt">
                  <div className="info-left-receipt">
                    <p>
                      <strong>Receipt No :</strong>{" "}
                      {studentRecord.receipt_number}
                    </p>
                    <p>
                      <strong>Student Name :</strong>{" "}
                      {studentRecord.studentname}
                    </p>
                    <p>
                      <strong>Registration No :</strong>{" "}
                      {studentRecord.registration_id}
                    </p>
                    <p>
                      <strong>Mobile No :</strong> {studentRecord.phone}
                    </p>
                  </div>
                  <div className="info-right-receipt">
                    <p>
                      <strong>Receipt Date :</strong>{" "}
                      {studentRecord.payment_date}
                    </p>
                    <p>
                      <strong>Parent's Name :</strong>{" "}
                      {studentRecord.parent_name}
                    </p>
                    <p>
                      <strong>Class :</strong> {studentRecord.classname} (
                      {studentRecord.sectionname})
                    </p>
                    <p>
                      <strong>Parent's Contact :</strong>{" "}
                      {studentRecord.parentphone}
                    </p>
                    <p>
                      <strong>Total Fee Paid (Overall) :</strong>{" "}
                      {overallPaidTotal}
                    </p>
                  </div>
                </div>
                <table className="table-receipt">
                  <thead>
                    <tr>
                      <th>S. No.</th>
                      <th>Particulars</th>
                      <th>Due Month</th>
                      <th>Due Amount</th>
                      <th>Concession Amount</th>
                      <th>Paid Amount</th>
                    </tr>
                  </thead>
                  <tbody>
                    {headRecordsWithPayment.map((item, index) => (
                      <tr key={index}>
                        <td className="text-center">{index + 1}</td>
                        <td>{item.headname}</td>
                        <td className="text-center">
                          {(Array.isArray(item.month) ? item.month : []).map((month, idx) => (
                            <div key={idx}>{month}</div>
                          ))}
                        </td>
                        <td className="amount text-right">{item.head_amount}</td>
                        <td className="amount text-right">{item.displayDiscount || 0}</td>
                        <td className="amount text-right">{item.paidInThisReceipt}</td>
                      </tr>
                    ))}
                  </tbody>
                  <tfoot>
                    <tr>
                      <td colSpan="5" className="text-right">
                        <strong>Total Amount (Gross) (in Rs):</strong>
                      </td>
                      <td className="amount text-right">
                        <strong>{totalFees}</strong>
                      </td>
                    </tr>
                    {parseSafe(totalDiscount) > 0 && (
                      <tr>
                        <td colSpan="5" className="text-right">
                          <strong>Total Concession (in Rs):</strong>
                        </td>
                        <td className="amount text-right">
                          <strong>{totalDiscount}</strong>
                        </td>
                      </tr>
                    )}
                    {parseSafe(totalDiscount) > 0 && (
                      <tr style={{ backgroundColor: '#f0f0f0' }}>
                        <td colSpan="5" className="text-right">
                          <strong>Net Payable Amount (in Rs):</strong>
                        </td>
                        <td className="amount text-right">
                          <strong>{totalFees - totalDiscount}</strong>
                        </td>
                      </tr>
                    )}
                    <tr style={{ backgroundColor: '#f9f9f9' }}>
                      <td colSpan="5" className="text-right">
                        <strong>Current Paid (in Rs):</strong>
                      </td>
                      <td className="amount">
                        <strong>{studentRecord.amount}</strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="5" className="text-right">
                        <strong>Due Amount (Balance):</strong>
                      </td>
                      <td className="amount">
                        <strong>
                          {Math.max(0, (totalFees - totalDiscount) -
                            (parseSafe(studentRecord.previous_paid_total) + parseSafe(studentRecord.amount)))}
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="text-right">
                        <strong className="text-capitalize">
                          Amount In Words: Rupees{" "}
                          {convertNumberToWords(studentRecord.amount)} Only.
                        </strong>
                      </td>
                    </tr>
                    <tr>
                      <td colSpan="6" className="text-right">
                        <strong>Payment Mode:</strong>{" "}
                        {studentRecord.payment_method} |
                        {studentRecord.transaction_no ? (
                          <>
                            <strong>Cheque No. / Transaction Id:</strong>{" "}
                            {studentRecord.transaction_no} |
                          </>
                        ) : null}
                        <strong>Cheque Date / Transaction Date:</strong>{" "}
                        {studentRecord.transaction_date}
                      </td>
                    </tr>
                  </tfoot>
                </table>

                <div className="remarks-receipt">
                  <p>
                    <strong>Remark:</strong> {studentRecord.remark}
                  </p>
                </div>
                <div className="footer-receipt">
                  <p>
                    Generated by {studentRecord.generated_by} on{" "}
                    {studentRecord.generated_date}
                  </p>
                  <p>
                    <strong>NOTE:</strong> FEE IS NOT REFUNDABLE (EXCEPT CAUTION
                    FEE)
                  </p>
                </div>
              </div>
            ))}
            <div className="dotted-line"></div>
          </div>
        ) : (
          <p>No Receipt Found</p>
        )}
      </div>
    </>
  );
});

export default FeeReceipt;
